<template>
    <aside id="sidenav-main"
        class="sidenav navbar navbar-vertical navbar-expand-xs my-0  fixed-start ms-0 border-0 sidenav-dark fixed-start py-0"
        :data-color="sidenavActiveBgColors" @mouseenter="openHover = true" @mouseleave="openHover = false">
        <div class="sidenav-header">
            <i id="iconSidenav"
                class="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none"
                aria-hidden="true"></i>
            <a id="migps-icon" class="m-0 navbar-brand d-flex align-items-center" href="/">
                <img id="migps-small" :src="logoPin" class="navbar-brand-img h-100" alt="MIGPS" />
            </a>
        </div>
        <sidenav-list :card-bg="customClass" :openHover="openHover" />
        <div class="bottom-nav">
            <Logout />
            <Footer />
        </div>
    </aside>
</template>

<script>
import SidenavList from "./SidenavList.vue";
import logoPin from "@/assets/img/logos/migps/logo-migps.png";
import Logout from '../PageLayout/Logout.vue';
import Footer from '@/templates/PageLayout/Footer.vue';

export default {
    name: "IndexComponent",
    components: {
        SidenavList,
        Logout,
        Footer
    },
    props: {
        customClass: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            logoPin,
            sidenavActiveBgColors: "success",
            openHover: false,
        };
    },
};
</script>

<style scoped>
.navbar-vertical.bg-white {
    box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.2);
}

aside#sidenav-main .sidenav-header {
    display: flex;
    justify-content: center;
}

aside#sidenav-main .sidenav-header img {
    max-height: 32px;
    height: 32px !important;
}

.sidenav .navbar-brand {
    padding: 1.5rem;
}

aside#sidenav-main.sidenav-dark .sidenav-header img#migps-small {
    height: auto !important;
    max-height: 60px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
}

.bottom-nav {
    width: 100%;
    position: absolute;
    bottom: 5px;
}

aside#sidenav-main {
    z-index: 1000;
}
</style>

<style>
/* ===== Dark sidenav theme ===== */
aside#sidenav-main.sidenav-dark {
    background: linear-gradient(180deg, #26343e 0%, #1d2930 100%) !important;
    box-shadow: 4px 0 18px rgba(0, 0, 0, 0.16);
}

/* top-level links: light text */
aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item > .nav-link,
aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item > .nav-link .nav-link-text,
aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item > .nav-link .fa-chevron-down {
    color: #eaf6f7 !important;
}

/* strip the white icon box + make the icon bigger / less padding */
aside#sidenav-main.sidenav-dark .nav-link .icon {
    background-image: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
    width: 36px !important;
    height: 36px !important;
    min-width: 36px !important;
    padding: 0 !important;
}

/* icon glyphs: white + larger */
aside#sidenav-main.sidenav-dark .nav-link .icon svg {
    width: 21px !important;
    height: 21px !important;
}
aside#sidenav-main.sidenav-dark .nav-link .icon svg path,
aside#sidenav-main.sidenav-dark .nav-link .icon i {
    fill: #ffffff !important;
    color: #ffffff !important;
}
aside#sidenav-main.sidenav-dark .nav-link .icon i {
    font-size: 17px !important;
}

/* hover row */
aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item > .nav-link:hover {
    background-color: rgba(255, 255, 255, 0.08) !important;
    border-radius: 10px;
    color: #ffffff !important;
}

/* active pill: light teal + dark content */
aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item > .nav-link.active {
    background-color: var(--blue-accent) !important;
    border-radius: 10px;
    box-shadow: 0 6px 16px rgba(136, 219, 223, 0.28);
}
aside#sidenav-main.sidenav-dark .nav-link.active,
aside#sidenav-main.sidenav-dark .nav-link.active .nav-link-text,
aside#sidenav-main.sidenav-dark .nav-link.active .fa-chevron-down {
    color: #06403f !important;
}
aside#sidenav-main.sidenav-dark .nav-link.active .icon svg path,
aside#sidenav-main.sidenav-dark .nav-link.active .icon i {
    fill: #06403f !important;
    color: #06403f !important;
}

/* ===== Submenu as a right-side flyout ===== */
/* panel look + readable links (applies in all widths) */
aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item > .collapse {
    background-color: #2c3d48 !important;
    border-radius: 10px;
    box-shadow: 0 12px 30px -6px rgba(0, 0, 0, 0.5);
    padding: 8px;
    min-width: 210px;
    max-width: 260px;
}
aside#sidenav-main.sidenav-dark .collapse ul.nav {
    margin-left: 0 !important;
    padding-left: 0 !important;
    min-height: 0 !important;
}
aside#sidenav-main.sidenav-dark .collapse .nav-link-collapse {
    display: block;
    padding: 7px 12px;
    border-radius: 6px;
    color: #eaf6f7 !important;
}
aside#sidenav-main.sidenav-dark .collapse .nav-link-collapse .sidenav-normal {
    color: #eaf6f7 !important;
    opacity: 1 !important;
    width: auto !important;
}
aside#sidenav-main.sidenav-dark .collapse .nav-link-collapse:hover {
    background-color: rgba(255, 255, 255, 0.10);
}
/* scrollbar */
aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item > .collapse::-webkit-scrollbar {
    width: 6px;
}
aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item > .collapse::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.25);
    border-radius: 3px;
}
aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item > .collapse::-webkit-scrollbar-track {
    background: transparent;
}

/* fixed flyout to the right (desktop) so it escapes the sidebar's scroll clip */
@media (min-width: 1200px) {
    aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item > .collapse {
        position: fixed !important;
        left: 15.5rem;
        max-height: 60vh !important;
        overflow-y: auto !important;
        overflow-x: hidden;
        z-index: 1200;
    }
    aside#sidenav-main.sidenav-dark .navbar-nav > .nav-item:hover > .collapse {
        display: block !important;
    }
}

@media (min-width: 1200px) {
    .navbar-vertical.navbar-expand-xs {
        display: block;
        position: fixed;
        top: 0;
        bottom: 0;
        width: 100%;
        min-width: 6rem;
        max-width: 15.625rem;
        /* PARA ACTIVAR EL ANCHO EN EL HOVER */
        overflow-y: auto;
        padding: 0;
        box-shadow: none;
    }

    .g-sidenav-hidden .navbar-vertical {
        max-width: 6rem !important;
    }

    .g-sidenav-hidden .navbar-vertical:hover {
        max-width: 15.625rem !important;
    }

    .g-sidenav-hidden .navbar-vertical:hover.fixed-start~.main-content {
        margin-left: 17.125rem;
    }

    .g-sidenav-hidden .navbar-vertical:hover .navbar-brand span {
        opacity: 1;
    }

    .g-sidenav-hidden .navbar-vertical:hover .nav-item .nav-link .nav-link-text,
    .g-sidenav-hidden .navbar-vertical:hover .nav-item .nav-link .sidenav-normal {
        opacity: 1;
        width: auto;
    }

    .g-sidenav-hidden .navbar-vertical:hover .nav-item .nav-link .sidenav-mini-icon {
        opacity: 0;
        width: 0;
        min-width: 0;
    }

    .g-sidenav-hidden .navbar-vertical:hover .nav-item .nav-link[data-bs-toggle="collapse"]:after {
        content: "\f107";
    }

    .g-sidenav-hidden .navbar-vertical:hover .nav-item .collapse .nav {
        margin-left: 1.5rem !important;
        padding-left: 1rem !important;
    }

    .g-sidenav-hidden .navbar-vertical:hover .nav-item .collapse .nav .nav-item .nav-link {
        margin-left: 1.35rem;
    }

    .g-sidenav-hidden .navbar-vertical:hover .nav-item .collapse .nav .nav-item .nav-link:before {
        content: "";
    }

    .g-sidenav-hidden .navbar-vertical:hover .nav-item .collapse .nav .nav-item .collapse .nav,
    .g-sidenav-hidden .navbar-vertical:hover .nav-item .collapse .nav .nav-item .collapsing .nav {
        margin-left: 0 !important;
        padding-left: 0 !important;
    }

    .g-sidenav-hidden .navbar-vertical:hover .nav-item .collapse .nav .nav-item .collapse .nav .nav-item .nav-link:before,
    .g-sidenav-hidden .navbar-vertical:hover .nav-item .collapse .nav .nav-item .collapsing .nav .nav-item .nav-link:before {
        content: none;
    }

    .g-sidenav-hidden .navbar-vertical:hover .card.card-background .icon-shape {
        margin-bottom: 1rem !important;
    }

    .g-sidenav-hidden .navbar-vertical:hover .card.card-background .docs-info {
        opacity: 1;
        width: auto;
        height: auto;
    }
}
</style>